"use strict";
import _ from 'lodash';
import cached from '../../../../../cachedData/sports';

function getInitialState () {
	return _.keyBy(cached.collections.sportCollection.list, 'sportId');
}

export default {getInitialState};

